import { FikoYTKokBilesenComponent } from '../../../../../service/kok-bilesen/kok-bilesen.component';
import { FikoYTKartComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-kart/fikoyt-kart.component';
import { FikoYTDalgaComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-dalga/fikoyt-dalga.component';
import { NgOptimizedImage } from '@angular/common';
import { Component, viewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTypographyModule } from 'ng-zorro-antd/typography';


@Component({
  selector: 'fikoyt-sifre-sifirla',
  imports: [
    NgOptimizedImage, RouterLink, FikoYTKartComponent, NzWaveModule, NzAlertComponent, NzInputModule, NzButtonComponent, NzIconModule, NzTypographyModule],
  templateUrl: './sifre-sifirla.component.html',
  standalone: true,
  styleUrl: './sifre-sifirla.component.less'
})
export class SifreSifirlaComponent extends FikoYTKokBilesenComponent {
  readonly rippleComponent = viewChild.required<FikoYTDalgaComponent>('ripple');


}
